// Database
jQuery(function ($) {
  if (
    $(
      "form#database-search, form#region-compare-database-search, #gq-database-country"
    ).length <= 0
  ) {
    return;
  }

  $(window).on("load", function () {
    if ($("#database-country").length > 0) {
      $("#database-country").val("");
    }
    if ($("#database-question").length > 0) {
      $("#database-question").val("");
    }
    if ($("#gq-database-country").length > 0) {
      $("#gq-database-country").val("");
    }
    if ($("#gq-database-quota-type").length > 0) {
      $("#gq-database-quota-type").val("");
    }
  });

  $("#database-search").on("submit", function (e) {
    e.preventDefault();

    const countryRegionId = $("#database-country").val();
    const questionId = $("#database-question").val();
    const databaseThemeId = $("#database-theme").val();

    console.log("countryRegionId", countryRegionId);
    console.log("questionId", questionId);

    // Only country/region is selected
    if (
      countryRegionId !== "" &&
      (questionId === "" || questionId === undefined)
    ) {
      $("#fake-loading").fadeIn();

      if (countryRegionId.split("---")[0] === "country") {
        window.location =
          "/data-tools/data/country?country=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }

      if (countryRegionId.split("---")[0] === "region") {
        if (countryRegionId.split("---")[1] === "all") {
          window.location =
            "/data-tools/data/region?countries=all" +
            "&database_theme=" +
            databaseThemeId;
        } else {
          window.location =
            "/data-tools/data/region?region=" +
            countryRegionId.split("---")[1] +
            "&database_theme=" +
            databaseThemeId;
        }
      }

      if (countryRegionId.split("---")[0] === "political_entity") {
        window.location =
          "/data-tools/data/region?political_entity=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }

      if (countryRegionId.split("---")[0] === "continent") {
        window.location =
          "/data-tools/data/region?continent=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }
    }

    // Only question is selected
    if (
      (countryRegionId === "" || countryRegionId === undefined) &&
      questionId !== ""
    ) {
      $("#fake-loading").fadeIn();
      window.location =
        "/data-tools/data/question?question_id=" +
        questionId +
        "&database_theme=" +
        databaseThemeId;
    }

    if (
      countryRegionId !== "" &&
      countryRegionId !== undefined &&
      questionId !== "" &&
      questionId !== undefined
    ) {
      if (countryRegionId.split("---")[0] === "country") {
        $("#fake-loading").fadeIn();
        window.location =
          "/data-tools/data/question-country?question_id=" +
          questionId +
          "&country=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }

      if (countryRegionId.split("---")[0] === "region") {
        $("#fake-loading").fadeIn();

        if (countryRegionId.split("---")[1] === "all") {
          window.location =
            "/data-tools/data/question-region?question_id=" +
            questionId +
            "&countries=all" +
            "&database_theme=" +
            databaseThemeId;
        } else {
          window.location =
            "/data-tools/data/question-region?question_id=" +
            questionId +
            "&region=" +
            countryRegionId.split("---")[1] +
            "&database_theme=" +
            databaseThemeId;
        }
      }

      if (countryRegionId.split("---")[0] === "political_entity") {
        $("#fake-loading").fadeIn();
        window.location =
          "/data-tools/data/question-region?question_id=" +
          questionId +
          "&political_entity=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }

      if (countryRegionId.split("---")[0] === "continent") {
        $("#fake-loading").fadeIn();
        window.location =
          "/data-tools/data/question-region?question_id=" +
          questionId +
          "&continent=" +
          countryRegionId.split("---")[1] +
          "&database_theme=" +
          databaseThemeId;
      }
    }
  });

  $(".show-fake-loading").on("click", function () {
    $("#fake-loading").fadeIn();
  });

  $(window).on("unload", function () {
    $("#fake-loading").hide();
  });

  $("#search-country-filter").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $(".database-results tbody tr").filter(function () {
      $(this).toggle(
        $(this).find("td:first-child").text().toLowerCase().indexOf(value) > -1
      );
    });
  });

  $("#question-filter-by-value").on("change", function () {
    $(".database-results tbody tr").show();
    var selectedOption = $(this).find("option:selected");
    var value = selectedOption.val();

    if (selectedOption.val().toLowerCase() === "any") {
      $(".database-results tbody tr").show();
    } else {
      $(".database-results tbody tr")
      .filter(function () {
        var text = $(this).find(".textanswer").text();
        return text.indexOf(value) === -1;
      })
      .hide();
    }
  });

  $(".vselect-gq-country").each(function () {
    const s = $(this);
    let settings = {};

    if (s.data("multi-select") !== undefined) {
      settings.multiSelect = s.data("multi-select");
    }
    if (s.data("search") !== undefined) {
      settings.search = s.data("search");
    }
    if (s.data("placeholder") !== undefined) {
      settings.placeholder = s.data("placeholder");
    }
    if (s.data("display") !== undefined) {
      settings.display = s.data("display");
    }

    settings.onChange = function (values, options) {
      const selectedOption = values.value;

      if (s.data("action") === "redirect" && selectedOption !== "") {
        $("#fake-loading").fadeIn();
        window.location =
          "/data-tools/data/gender-quotas-database/country?country=" +
          selectedOption;
      }
    };

    settings.searchPosition = -1;

    s.vSelect(settings);
  });

  $(".vselect-gq-quota-type").each(function () {
    const s = $(this);
    let settings = {};

    if (s.data("multi-select") !== undefined) {
      settings.multiSelect = s.data("multi-select");
    }
    if (s.data("search") !== undefined) {
      settings.search = s.data("search");
    }
    if (s.data("placeholder") !== undefined) {
      settings.placeholder = s.data("placeholder");
    }
    if (s.data("display") !== undefined) {
      settings.display = s.data("display");
    }

    settings.onChange = function (values, options) {
      const selectedOption = values.value;

      if (s.data("action") === "redirect" && selectedOption !== "") {
        $("#fake-loading").fadeIn();
        window.location = selectedOption;
      }
    };

    settings.searchPosition = -1;

    s.vSelect(settings);
  });

  // Regional comparison search form # //////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $("#region-compare-database-search").on("submit", function (e) {
    e.preventDefault();
    const compareForm = $(this);
    compareForm.find(".form-error").remove();

    const formKeys = ["regionA", "regionB", "db-question", "database-theme"];
    const requiredKeys = {
      regionA: "This field is required",
      "db-question": "This field is required",
      "database-theme": "Database theme is required",
    };

    let data = {};
    formKeys.map((key) => {
      const value = $("#" + key).val();
      if (value) {
        data[key] = value;
      }
    });

    let validate = {};
    Object.keys(requiredKeys).map((key) => {
      const value = data[key];
      if (value === "" || value === undefined || value === null) {
        validate[key] = requiredKeys[key];
      }
    });

    if (Object.keys(validate).length > 0) {
      Object.keys(validate).map((key) => {
        const element = $("#" + key);
        const errorMessage = `<div class="form-error text-red-500 font-bold text-mobileS mt-2">${validate[key]}</div>`;

        if (element.next(".vselect-container").length > 0) {
          $(errorMessage).insertAfter(element.next(".vselect-container"));
        } else {
          compareForm.append(errorMessage);
        }
      });
      return;
    }

    // Validation successful
    let params = {
      database_theme: data["database-theme"],
      question_id: data["db-question"],
    };

    const regionKeysSuffix = ["A", "B"];
    regionKeysSuffix.map((suffix) => {
      const selectedValue = data["region" + suffix];
      if (selectedValue) {
        const type = selectedValue.split("---")[0];
        const regionValue = selectedValue.split("---")[1];

        params["type" + suffix] = type;
        params["region" + suffix] = regionValue;
      }
    });

    const queryString = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");

    const newUrl = "/data-tools/data/region-compare" + "?" + queryString;

    $("#fake-loading").fadeIn();
    window.location = newUrl;
  });
  // Regional comparison search form # //////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
